import {
  GlobalSearchAdminTabsDefinition,
  GlobalSearchSuggestion,
} from '~/lib/types/navbar/global-search';
import { Path } from '~/routes/constants';

export enum GlobalSearchAdminTabs {
  USERS = 'Users',
}
export const GlobalSearchAdminTabsCollection: Record<
  GlobalSearchAdminTabs,
  GlobalSearchAdminTabsDefinition
> = {
  [GlobalSearchAdminTabs.USERS]: {
    basePath: Path.ADMIN_VIEW_PROFILE,
    label: 'Users',
  },
};

export type SearchResultsProps = {
  activeSuggestionIndex?: number;
  fetchSuggestions?: (searchTerm?: string, isFirstPage?: boolean) => void;
  getListItemId?: (value: string) => string;
  handleSelect: (
    option: GlobalSearchSuggestion | GetProviderByIdResponse,
  ) => void;
  id: string;
  inputValue?: string;
  isLoading: boolean;
  maxHeight: number;
  showUnknownIcon?: boolean;
  suggestions: (GlobalSearchSuggestion | GetProviderByIdResponse)[];
  totalOptionsCount?: number;
  fetchMoreProviders?: () => void; // Made optional
  highlightedIndex?: number; // Made optional
};
